$(document).ready(function () {

    function App() {
        var _self = this;
        var urlObject = {};
        var init = false;

        this.init = function () {
            _self.init = true;
            
            _self.scroll();
            _self.ui();
            
            let hash = window.location.hash;
            if (hash.length) {
                if (_self.getHash()) {
                    _self.urlObject = _self.getHash();
    
                    _self.filterResults();
                    _self.setSearchByObject();
                    
                    if (_self.hasModal()) {
                        $('#myModal').modal('show');
                    }
                    
                    if ($('.js-search-list-item.is-filtered').length == 1) {
                        $('.js-search-list-item.is-filtered').trigger('click');
                    }                    
                } else {
                    _self.updateUrl(_self.getSearchObject());
                }
            } else {
                _self.updateUrl(_self.getSearchObject());
            }
            
            _self.init = false;
            _self.popup();



            // debug
            // console.log( _self.urlObject );
            // console.log( GLOBAL_VARS.jobs_filter );
        }

        this.ui = function () {
            $('#myModal').on('show.bs.modal', function (e) {
                let href = '';
                if (typeof e.relatedTarget != 'undefined') {                    
                    href = e.relatedTarget.href;
                } else {
                    if (typeof _self.urlObject.modal != 'undefined') {
                        href = _self.urlObject.modal;
                    }
                }                

                $(this).find('.modal-content').load(href);
                _self.updateUrl(_self.getSearchObject(), href);
            });
            
            $('#myModal').on('hide.bs.modal', function (e) {
                _self.updateUrl(_self.getSearchObject());
                _self.popup();
            });

            $('.js-open-search-box').on('click', function(e) {
                e.preventDefault();

                let link = $(e.currentTarget);
                let originalElement = $(e.originalEvent.target);

                if (originalElement.hasClass('js-selected-item-close') || originalElement.parent().hasClass('js-selected-item-close') ) {
                    let key = originalElement.closest('.js-selected-item').data('key');

                    $(`.js-filter-checkbox[data-key="${key}"]`).trigger('click');

                    return false;
                }

                if (originalElement.hasClass('js-search-category-reset')) {
                    let type = $(originalElement).parent().parent().data('search-category');                    
                    
                    _self.resetSearch(type);
                    return false;
                }

                if (link.hasClass('is-active')) {
                    _self.closeSearchCategory();
                    _self.disableBgLayer();
                } else if ( $('.js-open-search-box.is-active').length > 0 ) {
                    _self.closeSearchCategory(link);
                    setTimeout(function () {
                        _self.openSearchCategory(link);
                    }, 0);
                } else {
                    _self.openSearchCategory(link);
                    _self.enableBgLayer();
                }
            });
            
            $('.js-bg-helper').on('click', function() {
                _self.closeSearchCategory();
                _self.disableBgLayer();
            });

            $('.js-search-box-close').on('click', function() {
                _self.closeSearchCategory();
                _self.disableBgLayer();
            });

            $('.js-filter-checkbox').on('click', function(e) {
                let input = $(e.currentTarget);
                let key = input.data('key');
                let value = input.data('value');
                let filterList = input.closest('.js-search-box').siblings('.js-open-search-box').find('.js-filter-list');

                if (input.is(':checked')) {
                    let _item = `<div class="selected-item js-selected-item" data-key="${key}">${value}<span class="selected-item__close js-selected-item-close"><i class="icon-close"></i></span></div>`;
                    filterList.append(_item);
                } else {
                    filterList.find(`[data-key="${key}"]`).remove();
                }

                if (!_self.init) {
                    _self.updateUrl(_self.getSearchObject());
                    setTimeout(() => {
                        _self.filterResults();                        
                    }, 0);
                }
            });

            $('.js-search-keyword').on('submit', function(e) {
                e.preventDefault();

                _self.updateUrl(_self.getSearchObject());
                setTimeout(() => {
                    _self.filterResults();                        
                }, 0);
            });

            $('.js-search-box-reset').on('click', function(e) {
                e.preventDefault();

                _self.init = true;
                _self.resetSearch();
                _self.init = false;

                _self.updateUrl(_self.getSearchObject());
                setTimeout(() => {
                    _self.filterResults();
                }, 0);
            });

            $('.js-search-list-expand').on('click', function(e) {
                e.preventDefault();                

                $('.js-search-list-item.is-filtered.d-none').slice(0,10).removeClass('d-none');

                if (!$('.js-search-list-item.is-filtered.d-none').length) {                    
                    $(e.currentTarget).addClass('d-none');
                }
            });
        }

        this.scroll = function () {
            $('.js-scroll-top').click(function () {
                $('html, body').animate({ scrollTop: 0 }, "slow");
                return false;
            });

            $(window).scroll(_self.debounce('100', function (event) {
                var scroll = $(window).scrollTop();
                if (scroll > 100) {
                    $('.js-scroll-top').removeClass('d-none');

                    setTimeout(function () {
                        $('.js-scroll-top').addClass('is-active');
                    }, 0);
                } else {
                    $('.js-scroll-top').removeClass('is-active');

                    setTimeout(function () {
                        $('.js-scroll-top').addClass('d-none');
                    }, 300);
                }
            }));
        }

        this.openSearchCategory = function(link) {
            let _target = $(link.attr('href'));
                        
            link.addClass('is-active');
            _target.removeClass('d-none');
            setTimeout(function () {
                _target.addClass('is-active');
            }, 0)
        }
        
        this.closeSearchCategory = function(link) {
            let _boxes = $('.js-search-box');
            $('.js-open-search-box').removeClass('is-active');
            _boxes.removeClass('is-active');
            setTimeout(function () {
                if (typeof link !== 'undefined') {                    
                    _boxes.not(link.attr('href')).addClass('d-none');
                } else {
                    _boxes.addClass('d-none');
                }
            }, 300);
        }

        this.enableBgLayer = function() {
            let layer = $('.js-bg-helper');

            layer.removeClass('d-none');
            setTimeout(function () {
                layer.addClass('is-active');
            }, 0);                        
        }

        this.disableBgLayer = function() {
            let layer = $('.js-bg-helper');
            
            layer.removeClass('is-active');
            setTimeout(function () {
                layer.addClass('d-none');
            }, 300);
        }
        
        // this.toggleBgLayer = function() {
        //     let layer = $('.js-bg-helper');

        //     if (layer.hasClass('is-active')) {
        //         _self.disableBgLayer();
        //     } else {
        //         _self.enableBgLayer();
        //     }
        // }

        this.getSearchObject = function() {
            let result = {};
            let gradeElements = $('[data-search-category="grades"]').find('.js-filter-list').find('.js-selected-item');
            let planElements = $('[data-search-category="plans"]').find('.js-filter-list').find('.js-selected-item');
            let levelElements = $('[data-search-category="levels"]').find('.js-filter-list').find('.js-selected-item');
            
            let grades = [];
            gradeElements.each(function(){
                grades.push( $(this).data('key') );
            });
            result['grades'] = grades;

            let plans = [];
            planElements.each(function(){
                plans.push( $(this).data('key') );
            });
            result['plans'] = plans;

            let levels = [];
            levelElements.each(function(){
                levels.push( $(this).data('key') );
            });
            result['levels'] = levels;

            result['keyword'] = _self.getKeyword();            
            
            return result;
        }

        this.setSearchByObject = function() {            
            if (_self.urlObject.grades.length) {
                for (const key in _self.urlObject.grades) {
                    if (_self.urlObject.grades.hasOwnProperty(key)) {
                        const grade = String(_self.urlObject.grades[key]);
                        $('#search-category-grades').find(`.js-filter-checkbox[data-key="${grade}"]`).trigger('click');                        
                    }
                }
            }

            if (_self.urlObject.plans.length) {
                for (const key in _self.urlObject.plans) {
                    if (_self.urlObject.plans.hasOwnProperty(key)) {
                        const plan = String(_self.urlObject.plans[key]);
                        $('#search-category-plans').find(`.js-filter-checkbox[data-key="${plan}"]`).trigger('click');
                    }
                }
            }

            if (_self.urlObject.levels.length) {
                for (const key in _self.urlObject.levels) {
                    if (_self.urlObject.levels.hasOwnProperty(key)) {
                        const level = String(_self.urlObject.levels[key]);
                        $('#search-category-levels').find(`.js-filter-checkbox[data-key="${level}"]`).trigger('click');
                    }
                }
            }

            if (_self.urlObject.keyword.length) {
                $('.js-search-keyword [name="search"]').val(_self.urlObject.keyword);                
            }

            _self.updateSearchReset();
            _self.updateFilterCount();
        }

        this.updateSearchReset =  function() {
            $('.js-search-box-reset').addClass('d-none');
            $('.js-search-category-reset').addClass('d-none');
            
            if (_self.urlObject.grades.length) {
                $('.js-search-box-reset').removeClass('d-none');
                $('[data-search-category="grades"]').find(`.js-search-category-reset`).removeClass('d-none');
            }
            
            if (_self.urlObject.plans.length) {
                $('.js-search-box-reset').removeClass('d-none');
                $('[data-search-category="plans"]').find(`.js-search-category-reset`).removeClass('d-none');
            }
            
            if (_self.urlObject.levels.length) {
                $('.js-search-box-reset').removeClass('d-none');
                $('[data-search-category="levels"]').find(`.js-search-category-reset`).removeClass('d-none');
            }
            
            if (_self.urlObject.keyword.length) {
                $('.js-search-box-reset').removeClass('d-none');
            }
        }

        this.resetSearch = function(type) {            
            switch (type) {
                case 'grades':
                    $('[data-search-category="grades"]').siblings('.js-search-box').find('.aui-js-checkbox.is-checked .js-filter-checkbox').trigger('click');                    
                    break;

                case 'plans':
                    $('[data-search-category="plans"]').siblings('.js-search-box').find('.aui-js-checkbox.is-checked .js-filter-checkbox').trigger('click');
                    break;

                case 'levels':
                    $('[data-search-category="levels"]').siblings('.js-search-box').find('.aui-js-checkbox.is-checked .js-filter-checkbox').trigger('click');
                    break;

                default:
                    $('.js-search-keyword [name="search"]').val("");
                    $('.aui-js-checkbox.is-checked .js-filter-checkbox').trigger('click');
                    break;
            }
        }

        this.filterResults = function() {
            let result = [];

            $('.js-search-list-item').removeClass('is-filtered');
            $('.js-search-list-item').addClass('d-none');
            $('.js-search-list-expand').addClass('d-none');

            $('.js-search-list-item').each((index, value) => {
                let key = $(value).data('code');

                if (GLOBAL_VARS.jobs_filter.hasOwnProperty(key)) {
                    if ( _self.jobFitsByGrades(key) && _self.jobFitsByPlans(key) && _self.jobFitsByLevels(key) && _self.jobFitsByKeyword(key) ) {
                        result.push(key);


                        $(`.js-search-list-item[data-code="${key}"]`).addClass('is-filtered');

                        if ( result.length < 11 ) {
                            $(`.js-search-list-item[data-code="${key}"]`).removeClass('d-none');
                        } else {
                            $('.js-search-list-expand').removeClass('d-none');
                        }
                    }
                }
            });

            $('.js-search-count').html(result.length);
        }

        this.updateFilterCount = function() {            
            let gradeElements = $('[data-search-category="grades"]').next('.js-search-box').find('.js-filter-checkbox');
            let planElements = $('[data-search-category="plans"]').next('.js-search-box').find('.js-filter-checkbox');
            let levelElements = $('[data-search-category="levels"]').next('.js-search-box').find('.js-filter-checkbox');            

            gradeElements.each(function(){
                let grade = $(this).data('key');
                let count = 0;

                for (const key in GLOBAL_VARS.jobs_filter) {
                    if (GLOBAL_VARS.jobs_filter.hasOwnProperty(key)) {
                        const job = GLOBAL_VARS.jobs_filter[key];                        
    
                        if ( (grade == job.grade) && _self.jobFitsByPlans(key) && _self.jobFitsByLevels(key) && _self.jobFitsByKeyword(key) ) {
                            count++;
                        }
                    }
                }

                $(`.js-filter-checkbox[data-key="${grade}"]`).next('.aui-checkbox__label').find('.js-filter-count').html(`(${count})`);
            });

            planElements.each(function(){
                let plan = $(this).data('key');
                let count = 0;

                for (const key in GLOBAL_VARS.jobs_filter) {
                    if (GLOBAL_VARS.jobs_filter.hasOwnProperty(key)) {
                        const job = GLOBAL_VARS.jobs_filter[key];                        
    
                        if ( _self.jobFitsByGrades(key) && (plan == job.plan) && _self.jobFitsByLevels(key) && _self.jobFitsByKeyword(key) ) {
                            count++;
                        }
                    }
                }

                $(`.js-filter-checkbox[data-key="${plan}"]`).next('.aui-checkbox__label').find('.js-filter-count').html(`(${count})`);
            });

            levelElements.each(function(){
                let level = $(this).data('key');
                let count = 0;

                for (const key in GLOBAL_VARS.jobs_filter) {
                    if (GLOBAL_VARS.jobs_filter.hasOwnProperty(key)) {
                        const job = GLOBAL_VARS.jobs_filter[key];                        
    
                        if ( _self.jobFitsByGrades(key) && _self.jobFitsByPlans(key) && _self.jobFitsByKeyword(key) ) {
                            if ( (job.level_felsofok == 1) && (level == 3) ) {
                                count++;
                            }
                            
                            if ( (job.level_kozepfok == 1) && (level == 1) ) {
                                count++;
                            }
        
                            if ( (job.level_hallgato == 1) && (level == 2) ) {
                                count++;
                            }
                        }
                    }
                }

                $(`.js-filter-checkbox[data-key="${level}"]`).next('.aui-checkbox__label').find('.js-filter-count').html(`(${count})`);
            });
        }

        this.jobFitsByGrades = function(key) {
            const job = GLOBAL_VARS.jobs_filter[key];

            if (typeof _self.urlObject.grades != 'undefined' && _self.urlObject.grades.length) {
                for (let i = 0; i < _self.urlObject.grades.length; i++) {
                    const grade = _self.urlObject.grades[i];
                                        
                    if (job.grade == grade) {
                        return true;
                    }
                }
                return false;
            }
            return true;
        }

        this.jobFitsByPlans = function(key) {
            const job = GLOBAL_VARS.jobs_filter[key];

            if (typeof _self.urlObject.plans != 'undefined' && _self.urlObject.plans.length) {
                for (let i = 0; i < _self.urlObject.plans.length; i++) {
                    const plan = _self.urlObject.plans[i];                    
                    
                    if (job.plan == plan) {
                        return true;
                    }
                }
                return false;
            }
            return true;
        }

        this.jobFitsByLevels = function(key) {
            const job = GLOBAL_VARS.jobs_filter[key];

            if (typeof _self.urlObject.levels != 'undefined' && _self.urlObject.levels.length) {
                for (let i = 0; i < _self.urlObject.levels.length; i++) {
                    const level = _self.urlObject.levels[i];                    
                    
                    if ( (job.level_felsofok == 1) && (level == 3) ) {
                        return true;                        
                    }
                    
                    if ( (job.level_kozepfok == 1) && (level == 1) ) {
                        return true;                        
                    }

                    if ( (job.level_hallgato == 1) && (level == 2) ) {
                        return true;                        
                    }

                }
                return false;
            }
            return true;
        }

        this.jobFitsByKeyword = function(key) {
            const job = GLOBAL_VARS.jobs_filter[key];
            
            if (typeof _self.urlObject.keyword != 'undefined' && _self.urlObject.keyword.length) {
                if ( job.words.indexOf(_self.urlObject.keyword.toLowerCase()) >= 0 ) {
                    return true;
                } else {
                    return false;
                }                
            }
            return true;
        }

        this.updateUrl = function(searchObject, modal) {
            _self.urlObject = searchObject;
            
            if ( typeof modal != 'undefined' && modal.length) {
                _self.urlObject['modal'] = modal;
            }

            window.location.hash = encodeURIComponent(JSON.stringify(_self.urlObject));

            _self.updateSearchReset();
            _self.updateFilterCount();
        }

        this.getHash = function() {
            let hash = window.location.hash;
            if (hash.length) {
                hash = hash.substring(1);
                let json = false;
                
                try {
                    json = JSON.parse(decodeURIComponent(hash));
                } catch(e) {
                    // _self.updateUrl(_self.getSearchObject());
                } finally {                    
                    return(json);
                }
            }
        }

        this.getKeyword = function() {
            let search = $('.js-search-keyword').serializeArray();
            let result = "";
            
            $.each( search, function( i, field ) {
                if (field.name == "search") {
                    result = field.value;
                }
            });

            return result;
        }

        this.hasModal = function() {
            let url = _self.getHash();

            return typeof url.modal != 'undefined';
        }

        this.popup = function() {
            if ( $('#popupModal').length > 0 ) {
                let popupShown = Cookies.get('popupShown');            
    
                if (typeof popupShown == 'undefined') {                
                    setTimeout(() => {
                        if ( !$('body').hasClass('modal-open') ) {
                            Cookies.set('popupShown', 1, { expires: 1 })
                            $('#popupModal').modal('show');
                        }
                    }, 500);
                }                
            }
        }

        this.debounce = function (delay, fn) {
            let timerId;
            return function (...args) {
                if (timerId) {
                    clearTimeout(timerId);
                }
                timerId = setTimeout(() => {
                    fn(...args);
                    timerId = null;
                }, delay);
            }
        }
    }

    let app = new App();
    app.init();
});